class ContribuinteVinculo{
  constructor(){
    this.id = '';
    this.version = 0;
    this.idPessoa = '';
  }
}

export default ContribuinteVinculo;